import { createStore, createEvent } from "effector"
import { ReservationSidebarTab } from "components/ReservationSidebar/ReservationSidebar"

interface PendingReservationSidebarState {
    reservationId: string | null
    initTabIndex?: ReservationSidebarTab
    onDelete?: () => void
}

// Events
export const setPendingReservationSidebar = createEvent<{
    reservationId: string
    initTabIndex?: ReservationSidebarTab
    onDelete?: () => void
}>()

export const clearPendingReservationSidebar = createEvent()

// Store
export const $pendingReservationSidebar = createStore<PendingReservationSidebarState>({
    reservationId: null,
    initTabIndex: undefined,
    onDelete: undefined
})
    .on(setPendingReservationSidebar, (_, payload) => ({
        reservationId: payload.reservationId,
        initTabIndex: payload.initTabIndex,
        onDelete: payload.onDelete
    }))
    .on(clearPendingReservationSidebar, () => ({
        reservationId: null,
        initTabIndex: undefined,
        onDelete: undefined
    }))

export default {
    $pendingReservationSidebar,
    setPendingReservationSidebar,
    clearPendingReservationSidebar
}
